export default class Paginator {
  static Paginate(items, current_page, per_page_items) {
    let offset = 0;
    let limit = 0;

    switch (per_page_items) {
      case "10/page":
        limit = 10;
        break;
      case "20/page":
        limit = 20;
        break;

      case "30/page":
        limit = 30;
        break;

      case "40/page":
        limit = 40;
        break;

      case "50/page":
        limit = 50;
        break;

      case "100/page":
        limit = 100;
        break;

      case "ALL":
        return items;

      default:
        limit = 0;
        break;
    }

    current_page == 1 ? (offset = 0) : (offset = (current_page-1) * limit);

    if (items.length > 0) {
      let page = current_page || 1,
        per_page = limit || 10,
        // offset = (page - 1) * per_page,
        paginatedItems = items.slice(offset).slice(0, limit),
        total_pages = Math.ceil(items.length / per_page);

      return paginatedItems;
    }
    return [];
  }
}
